// Scenario records are shared context, never independently answerable questions.
export const isScenarioRecord = q => q?.recordKind === 'scenario';
export const sectionFor = q => isScenarioRecord(q) || q?.scenarioId ? 'B' : ['A', 'B', 'C'].includes(q?.section) ? q.section : q?.type === 'descriptive' ? 'C' : 'A';

export function attachScenarios(records, {allowUnavailable = false} = {}) {
    const byId = new Map(records.map(q => [q.id, q]));
    return records.filter(q => !isScenarioRecord(q)).map(q => {
        if (!q.scenarioId) return { ...q, section: sectionFor(q) };
        const shared = byId.get(q.scenarioId);
        const ids = shared?.subquestionIds;
        if (!isScenarioRecord(shared) || shared.paperId !== q.paperId || !Array.isArray(ids) || ids.length !== 5 || new Set(ids).size !== 5 || !ids.includes(q.id) || ids.some(id => byId.get(id)?.scenarioId !== shared.id)) {
            if(allowUnavailable)return {...q,section:'B',contentUnavailable:true};
            const error = new Error('The shared scenario or one of its five requirements is unavailable.');
            error.code = 'iq/content-unavailable';
            throw error;
        }
        const partNumber = ids.indexOf(q.id) + 1;
        return { ...q, contentUnavailable:Boolean(q.contentUnavailable || shared.contentUnavailable), section: 'B', scenarioOrder: partNumber - 1,
            scenario: { id: shared.id, title: shared.title, text: shared.text, images: shared.images, questionIds: ids, partNumber, total: ids.length },
            ...(!q.bunnyVideoId && shared.bunnyVideoId ? { bunnyVideoId: shared.bunnyVideoId, bunnyLibraryId: shared.bunnyLibraryId } : {}) };
    });
}

export function scenarioQueue(questions, requested) {
    if (!requested?.scenarioId) return null;
    return questions.filter(q => q.scenarioId === requested.scenarioId).sort((a, b) => a.scenarioOrder - b.scenarioOrder);
}

export function questionRouteParams(q) {
    return new URLSearchParams({ question: q.id, ...(q.scenarioId ? { scenario: q.scenarioId } : {}) });
}

export function managedQuestions(records, { section = '', sort = 'newest', search = '', text = value => String(value || '') } = {}) {
    const byId = new Map(records.map(q => [q.id, q]));
    const terms = search.toLowerCase().trim().split(/\s+/).filter(Boolean);
    const rows = records.filter(q => !q.scenarioId || !isScenarioRecord(byId.get(q.scenarioId))).filter(q => {
        const parts = isScenarioRecord(q) ? (q.subquestionIds || []).map(id => byId.get(id)).filter(Boolean) : [];
        const haystack = [q, ...parts].map(item => `${item.questionNumber || ''} ${item.title || ''} ${text(item.text)} ${item.topic || ''} ${(item.tags || []).join(' ')}`).join(' ').toLowerCase();
        return (!section || sectionFor(q) === section) && terms.every(t => haystack.includes(t));
    });
    const time = q => q.createdAt?.toMillis?.() || 0;
    const number = q => Number(q.questionNumber) || Math.min(...(q.subquestionIds || []).map(id => Number(byId.get(id)?.questionNumber) || Infinity), Infinity);
    return rows.sort((a, b) => (sort === 'section' ? sectionFor(a).localeCompare(sectionFor(b)) : sort === 'number' ? (number(a) === number(b) ? 0 : number(a) < number(b) ? -1 : 1) : 0) || time(b) - time(a) || String(a.id).localeCompare(String(b.id)));
}
